import React from 'react'
import { useTranslation } from 'react-i18next'
import { Col } from 'react-bootstrap'

import { DefaultSpinner } from '../Spinners'

interface Props {
	verificationTimeout: boolean
	verificationRejected: boolean
}

export const VideoIdPendingSigning = ({ verificationTimeout, verificationRejected }: Props) => {
	const { t } = useTranslation()

	return (
		<div className="sign-pn-otp-pending-verification">
			{verificationTimeout ? (
				<div className="sign-pn-otp-verification-timeout">
					{t('VideoIdVerificationTimeout')}
				</div>
			) : verificationRejected ? (
				<div className="sign-pn-otp-verification-rejected">
					{t('VideoIdVerificationRejected')}
				</div>
			) : (
				<>
					<div>{t('PendingVerificationInfo')}</div>
					<Col xs={12}>
						<DefaultSpinner />
					</Col>
				</>
			)}
		</div>
	)
}
